import React from "react";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import "./GameInformation.css";
import "bootstrap/dist/css/bootstrap.css";
import { browserHistory } from "react-router";
import axios from "axios";
import { connect } from "react-redux";
import {
  setGameInformation,
  setMainPageView,
  goBackBoolean,
  setMatchDatetime,
} from "../../../redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Link } from "react-router";
import { api_url, token } from "../../../utils/constantInformation";
import DoubleArrowTwoToneIcon from "@material-ui/icons/DoubleArrowTwoTone";
import {
  platform_logo_path_map,
  game_logo_path_map,
  feedbackEmail,
  contactUsEmail,
  version,
  spordiaPrivacyLink,
  spordiaTermsLink,
  spordiaWebsiteLink,
  faqLink,
} from "../../../utils/constantInformation";
import { getUserJwtToken, signOut } from "../../../utils/utils";
import { vbGameIDDatatimeInfo } from "../../../utils/scheduleInfo";
import Logout, {
  LockIcon,
  InfoIcon,
  AssignmentIcon,
  Spordia,
  HelpIcon,
  SettingsIcon,
  MailIcon,
  AnnouncementIcon,
  QuestionAnswerIcon,
  MoreVertIcon,
  SearchIcon,
} from "../../../utils/icons";
import SkeletonGameSlateInformation from "../../Skeleton/SkeletonGameSlateInformation";
import {
  setTeamFilter,
  setAutoLineupGenBarOpenFlag,
} from "../../../redux/GameInformation/GameInformationAction";
import AutoLineUp from "../AutoLineUp/AutoLineUp";

function GameInformation(props) {
  // <a href=https://www.searchpng.com/youve-reached-your-daily-download-limit-as-a-guest-sign-up-and-keep-downloading-resources/ >House photo created by Search png - www.searchpng.com</a>
  var subtitle;
  const [mainModal, setMainModal] = React.useState(false);
  const [platformModal, setPlatformModal] = React.useState(false);
  const [sportsModal, setSportsModal] = React.useState(false);
  const [showAutoLineUpComponent, setShowAutoLineUpComponent] =
    React.useState(false);

  const [platform_permanent, setPermanentPlatform] = React.useState("dream11");
  const [platform_temporary, setTemporaryPlatform] = React.useState("dream11");

  const [sports_permanent, setPermanentSports] = React.useState("VB");
  const [sports_temporary, setTemporarySports] = React.useState("VB");

  const [availabe_timeframes, setTimeframes] = React.useState([]);
  const [slates_available, setSlatesForSelectedTimeframe] = React.useState([]);
  const [complete_game_information, setComplateGameInformation] =
    React.useState(null);
  const [timeframe_permanent, setPermanentTimeframe] = React.useState(null);
  const [timeframe_temporary, setTemporayTimeframe] = React.useState(null);

  const [selected_slate, setSlate] = React.useState(null);

  // Timer States
  const [timeLeftDays, setTimeLeftDays] = React.useState(null);
  const [timeLeftHours, setTimeLeftHours] = React.useState(null);
  const [timeLeftMinutes, setTimeLeftMinutes] = React.useState(null);
  const [timeLeftSeconds, setTimeLeftSeconds] = React.useState(null);

  const [timer, setTimer] = React.useState(null);

  let interval = React.useRef();
  const startTimer = (gameDateTime) => {
    const countDownDate = new Date(gameDateTime).getTime();
    console.log("Timer", gameDateTime, countDownDate);
    interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = countDownDate - now;
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      if (difference < 0) {
        clearInterval(interval.current);
      } else {
        setTimeLeftDays(days);
        setTimeLeftHours(hours);
        setTimeLeftMinutes(minutes);
        setTimeLeftSeconds(seconds);
      }
    }, 1000);
  };

  React.useEffect(async () => {
    console.log(
      "Game Information reducer",
      props.game_information_info.gameInformationReducer
    );
    setPermanentPlatform(
      props.game_information_info.gameInformationReducer.platform
    );
    setPermanentSports(
      props.game_information_info.gameInformationReducer.sports
    );
    setPermanentTimeframe(
      props.game_information_info.gameInformationReducer.selected_timeframe
    );
    setTemporayTimeframe(
      props.game_information_info.gameInformationReducer.selected_timeframe
    );
    const jwtToken = await getUserJwtToken();
    const result = await axios
      .get(
        api_url +
          "/slate/" +
          encodeURIComponent(platform_temporary) +
          "/" +
          encodeURIComponent(sports_temporary),
        // "/PSL/game_slate/2021/all",
        {
          headers: {
            // "x-access-token": token,
            "Authorization": jwtToken,
            // ClientID: process.env.REACT_APP_COGNITO_CLIENT_ID,
            // "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        return res.data;
      });

    setComplateGameInformation(result);
    console.log("Complete Game Information::");
    console.log(result);
    var time_frames = [];
    var temp_check = [];
    result.forEach((el) => {
      if (temp_check.indexOf(el.slate_timeframe) == -1) {
        time_frames.push({
          slate_id: el.SlateID,
          slate_timeframe: el.slate_timeframe,
        });
        temp_check.push(el.slate_timeframe);
      }
    });

    setTimeframes(time_frames);
    // setTemporayTimeframe(time_frames[0].slate_timeframe);

    const slate_for_selected_timeframe = result.filter((el) => {
      return el.slate_timeframe == time_frames[0].slate_timeframe;
    });

    setSlatesForSelectedTimeframe(slate_for_selected_timeframe);
  }, [sports_temporary, showAutoLineUpComponent]);

  function openModal() {
    setMainModal(true);
  }

  function closeModal() {
    setMainModal(false);
    setPlatformModal(false);
    setSportsModal(false);
  }

  function openPlatformModal() {
    setPlatformModal(true);
    setMainModal(false);
  }

  function openSportsModal() {
    setSportsModal(true);
    setPlatformModal(false);
    setMainModal(false);
  }

  function setPlatformInformation(platform_name) {
    setTemporaryPlatform(platform_name);
    setPlatformModal(false);
    openSportsModal(true);
  }

  function setSportsInformation(sport_name) {
    setTemporarySports(sport_name);

    setSportsModal(false);
    openModal(true);
  }

  function openAutoLineUpComponent() {
    props.update_auto_lineup_generation_flag(true);
  }

  function setNewTimeFrame(timeframe) {
    console.log("Set new timeframe:: ", timeframe);
    console.log("complete game information:: ", complete_game_information);
    const available_slates = complete_game_information.filter((el) => {
      return el.slate_timeframe == timeframe;
    });
    console.log("Available Slates");
    console.log(available_slates);
    setSlatesForSelectedTimeframe(available_slates);
    setTemporayTimeframe(timeframe);
  }

  function saveAllSelections(slate_id, date) {
    console.log("[save all selections] Slate_id", slate_id);
    console.log("[save all selections] platform temperory", platform_temporary);
    console.log(
      "[save all selections] timeframe temperory",
      timeframe_temporary
    );
    setPermanentPlatform(platform_temporary);
    setPermanentSports(sports_temporary);
    props.update_filtered_team("Both");
    setTemporayTimeframe(vbGameIDDatatimeInfo[slate_id].split("T")[0]);
    // setPermanentTimeframe(vbGameIDDatatimeInfo[slate_id].split("T")[0]);
    setPermanentTimeframe(date);
    setSlate(slate_id);
    setMainModal(false);
    let game_info = {
      platform: platform_temporary,
      sports: sports_temporary,
      selected_timeframe: date,
      slate_id: slate_id,
    };
    props.game_information(game_info);
    // Setting countdown timer
    console.log(
      "[save all selections] Time to set for countdown timer",
      vbGameIDDatatimeInfo[slate_id].split("T")
    );
    props.set_datetime_for_countdown(vbGameIDDatatimeInfo[slate_id]);
  }

  function sortByProperty(property) {
    return function (a, b) {
      if (parseFloat(a[property]) > parseFloat(b[property])) return 1;
      else if (parseFloat(a[property]) < parseFloat(b[property])) return -1;

      return 0;
    };
  }

  function setTime(time) {
    var date = new Date(time);

    return date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function gotoExternalLink(link) {
    window.open(link);
  }

  function handleEmailClient(subject, ideas_flag) {
    let to_email = null;
    if (ideas_flag == true) {
      to_email = feedbackEmail;
    } else {
      to_email = contactUsEmail;
    }
    window.location.href = "mailto:" + to_email + "?subject=" + subject;
  }
  function changeView() {
    props.view_setter("default_page");
    props.go_back_boolean(true);
  }
  function scrollHorizontal(e) {
    e.preventDefault();
    var container = document.getElementById("ul-horizontal-scroll");
    var containerScrollPosition = document.getElementById(
      "ul-horizontal-scroll"
    ).scrollLeft;
    container.scrollTo({
      top: 0,
      left: containerScrollPosition + e.deltaY,
      behaviour: "smooth", //if you want smooth scrolling
    });
  }

  function displayDateFromSlateTimeFrame(slateDate) {
    const date = new Date(slateDate);
    // const idxToDayMap = {
    //   0: "Mon",
    //   1: "Mon",
    //   2: "Mon",
    //   3: "Mon",
    //   4: "Mon",
    //   0: "Mon",
    // }
    return (
      date.toDateString().split(" ")[0] +
      " " +
      date.getDate() +
      "/" +
      parseInt(date.getMonth() + 1)
    );
  }
  function handlesignOut() {
    console.log("Handle Sign out called");
    signOut();
    browserHistory.push("/app/signin");
  }
  function handleRequestDeletion() {
    console.log("Handle Request Deletion called");
    browserHistory.push("/app/deleteaccount");
  }
  const timeFrameDisplay = () => {
    const time = new Date(timeframe_permanent);
    const yyyy = time.getFullYear();
    let mm = time.getMonth() + 1; // Months start at 0!
    let dd = time.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const toReturn = dd + "/" + mm;
    //  + "-" + yyyy;
    console.log("Date Permanent Timeframe:: ", toReturn);
    return <span className="text-white"> | {toReturn}</span>;
  };
  return (
    <>
      {props.game_information_info.gameInformationReducer
        .auto_lineup_gen_bar_open_flag ? (
        <AutoLineUp />
      ) : (
        <></>
      )}
      <nav className="navbar navbar-expand-md fixed-top-sm flex-nowrap justify-content-between bg-dark navbar-dark">
        <Link
          to="/app"
          onClick={changeView}
          style={
            props.game_information_info.gameInformationReducer.view_selected ==
            "Players"
              ? {}
              : { display: "none" }
          }
          className="align-items-center align-self-center"
        >
          <ArrowBackIosIcon className="align-items-center align-self-center text-primary"></ArrowBackIosIcon>
        </Link>

        <Link
          style={
            props.game_information_info.gameInformationReducer.view_selected ==
            "Players"
              ? { display: "none" }
              : {}
          }
        >
          <SettingsIcon
            className="align-items-center align-self-center text-primary"
            data-toggle="modal"
            data-target="#staticBackdropUserProfile"
            style={{ cursor: "pointer" }}
            disabled={
              props.game_information_info.gameInformationReducer
                .view_selected == "Players"
                ? true
                : false
            }
          ></SettingsIcon>
        </Link>
        {/* </p> */}
        {/* <p className="nav-item active align-items-center align-self-center"> */}
        <button
          className="btn px-2 nav-item active align-items-center align-self-center central-button"
          // onClick={openModal}
          data-toggle="modal"
          data-target="#staticBackdrop"
          disabled={
            props.game_information_info.gameInformationReducer.view_selected ==
            "Players"
              ? true
              : false
          }
        >
          <span>
            <img
              src={`${platform_logo_path_map[platform_permanent]}`}
              className="platform__logo"
            />
          </span>
          <span className="text-white">{" | "}</span>{" "}
          <span>
            <img
              src={`${game_logo_path_map[sports_permanent]}`}
              className="platform__logo" // game__logo
            />
          </span>
          <span className="text-white">{timeFrameDisplay()}</span>
          <p className="m-0 p-0 text-primary lead">
            <b className="text-bold">DailyFantasy </b>
            <span>
              <DoubleArrowTwoToneIcon className="rotate-90-clock" />
            </span>
          </p>
        </button>
        <div className="d-flex justify-content-center">
          <MoreVertIcon
            className="align-items-center align-self-center text-primary ml-1 morevert_logo"
            data-toggle="modal"
            data-target="#staticBackdropLineUp"
            style={{ cursor: "pointer", visibility: "hidden" }}
            disabled={
              props.game_information_info.gameInformationReducer
                .view_selected == "Players"
                ? true
                : false
            }
          ></MoreVertIcon>
        </div>

        {/* <img
          src={process.env.PUBLIC_URL + "/res/spordia_logo.png"}
          className="text-primary mr-1 spordia_logo"
          style={{ objectFit: "contain", width: "28px", height: "100%" }}
        /> */}
        {/* <SportsCricketIcon className="text-primary gameInformation__logo" /> */}
        {/* </ul> */}
        <button
          className="navbar-toggler ml-auto"
          type="button"
          data-toggle="collapse"
          data-target="#navbar2"
          style={
            props.game_information_info.gameInformationReducer.view_selected ==
            "Players"
              ? { display: "none" }
              : {}
          }
        >
          <span
            className="navbar-toggler-icon"
            style={
              props.game_information_info.gameInformationReducer
                .view_selected == "Players"
                ? { display: "none" }
                : {}
            }
          ></span>
        </button>
      </nav>
      {/* ---------------------Main Modal------------------------------         */}

      <div
        class="modal fade"
        id="staticBackdrop"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        {slates_available.length > 0 ? (
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex bg-dark">
                <button
                  className="btn btn-outline-primary align-items-center"
                  // onClick={openPlatformModal}
                >
                  {platform_temporary}
                </button>
                <ArrowForwardIosIcon className=" align-self-center align-items-center ml-2 text-white"></ArrowForwardIosIcon>
                <button
                  className="btn btn-outline-primary align-items-center ml-2"
                  // onClick={openPlatformModal}
                >
                  {sports_temporary}
                </button>
                <button
                  type="button"
                  class="close align-items-center text-white"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="bg-black">
                <div className="bg-black">
                  <ul
                    className="scrolling-wrapper list-group list-group-horizontal"
                    id="ul-horizontal-scroll"
                    onWheel={(e) => scrollHorizontal(e)}
                  >
                    {availabe_timeframes.map((game_timeframe, index) => (
                      <li
                        className="btn btn-secondary m-2 text-nowrap"
                        onClick={() =>
                          setNewTimeFrame(game_timeframe.slate_timeframe)
                        }
                        key={index}
                      >
                        {displayDateFromSlateTimeFrame(
                          game_timeframe.slate_timeframe
                        )}
                        {/* {game_timeframe.slate_timeframe} */}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-black">
                  <div className="d-flex justify-content-center align-items-center bg-dark p-2">
                    <h4 className="align-items-center align-self-center text-white">
                      Classic{" "}
                      <small className="align-items-center align-self-center text-secondary">
                        ({slates_available.length})
                      </small>
                    </h4>
                  </div>
                  <div className="container-fluid bg-black">
                    {slates_available
                      .sort(sortByProperty("Time"))
                      .map((slate, index) => (
                        <div
                          className="card m-1 p-0 bg-secondary"
                          data-dismiss="modal"
                          onClick={() => {
                            saveAllSelections(slate.SlateGameID, slate.Date);
                          }}
                        >
                          <div className="card-body m-1 p-0">
                            <div className="d-flex justify-content-between m-0 p-0">
                              <div className="m-0 p-0">
                                <p className="text-white m-0">
                                  <b>{setTime(slate.GameDateTime)}</b>
                                </p>
                                <p className="m-0">DailyFantasy</p>
                                <div className="border border-white rounded">
                                  <p className="p-2 m-0">
                                    {slate.Team} vs {slate.Opponent}
                                  </p>
                                </div>
                              </div>
                              <div>
                                <p className="text-red">
                                  <b>Announced</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <SkeletonGameSlateInformation />
        )}
      </div>

      <div
        className="modal fade"
        id="staticBackdropUserProfile"
        data-backdrop="staticUserProfile"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabelUserProfile"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header d-flex bg-dark text-center text-white lead">
              <span>Hi {props.userEmail}</span>
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="bg-black">
              <ul class="list-group m-2">
                <li
                  class="d-flex list-group-item bg-dark text-white"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  data-dismiss="modal"
                  onClick={handlesignOut}
                  style={{ cursor: "pointer" }}
                >
                  <Logout className=" align-items-center align-self-center mr-3" />
                  <span className="align-items-center align-self-center ml-2">
                    Sign out
                  </span>
                </li>
              </ul>

              <ul class="list-group m-2">
                <li
                  class="d-flex list-group-item bg-dark text-white"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  style={{ cursor: "pointer" }}
                  data-toggle="collapse"
                  data-target="#collapseExample"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  <HelpIcon className="text-primary align-items-center align-self-center mr-2" />
                  <span className="align-items-center align-self-center ml-2">
                    Feedback & Support
                  </span>
                </li>
                <div class="collapse" id="collapseExample">
                  <ul class="list-group m-2">
                    <li
                      class="d-flex list-group-item bg-dark text-white"
                      onClick={() => {
                        gotoExternalLink(faqLink);
                      }}
                    >
                      <QuestionAnswerIcon className="text-primary align-items-center align-self-center mr-3" />
                      <span className="align-items-center align-self-center">
                        Frequently Asked Questions
                      </span>
                    </li>

                    <li
                      class="d-flex list-group-item bg-dark text-white"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleEmailClient("Ideas and Suggestions", true);
                      }}
                    >
                      <AnnouncementIcon className="text-primary align-items-center align-self-center mr-3" />
                      <span className="align-items-center align-self-center">
                        Ideas & Suggestions
                      </span>
                    </li>
                    <li
                      class="d-flex list-group-item bg-dark text-white"
                      onClick={() => {
                        handleEmailClient("Feedback", false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <MailIcon className="text-primary align-items-center align-self-center mr-3" />
                      <span className="align-items-center align-self-center">
                        Contact Us
                      </span>
                    </li>
                  </ul>
                </div>
              </ul>

              <ul class="list-group m-2">
                <li class="d-flex list-group-item bg-dark text-white">
                  <Spordia className="align-items-center align-self-center" />
                  <span className="align-items-center align-self-center">
                    Spordia IPL
                  </span>
                </li>
                <li
                  class="d-flex list-group-item bg-dark text-white"
                  onClick={() => {
                    gotoExternalLink(spordiaWebsiteLink);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <Spordia className="align-items-center align-self-center" />
                  <span className="align-items-center align-self-center">
                    Developed By Spordia Softech Pvt Ltd
                  </span>
                </li>
                <li class="list-group-item bg-dark text-white d-flex ">
                  <InfoIcon className="text-primary align-items-center align-self-center mr-3" />
                  <div className="d-flex justify-content-between w-100">
                    <span className="align-items-center align-self-center">
                      App Version{" "}
                    </span>
                    <span className="lead">
                      <small>{version}</small>
                    </span>
                  </div>
                </li>
                <li
                  class="d-flex list-group-item bg-dark text-white"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    gotoExternalLink(spordiaTermsLink);
                  }}
                >
                  <AssignmentIcon className="text-primary align-items-center align-self-center mr-3" />
                  <span className="align-items-center align-self-center">
                    Terms of Use
                  </span>
                </li>
                <li
                  class="d-flex list-group-item bg-dark text-white"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    gotoExternalLink(spordiaPrivacyLink);
                  }}
                >
                  <LockIcon className="text-primary align-items-center align-self-center mr-3" />
                  <span className="align-items-center align-self-center">
                    Privacy Policy
                  </span>
                </li>
              </ul>
            </div>

            <div class="modal-footer bg-black">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Lineup Modal */}
      <div
        className="modal fade"
        id="staticBackdropLineUp"
        data-backdrop="staticLineUp"
        tabindex="-1"
        role="dialog"
        aria-labelledby="staticBackdropLabelLineUp"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header d-flex bg-dark text-center text-white lead">
              Lineup Generation
              <button
                type="button"
                className="close text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="bg-black">
              <div className="list-group bg-dark text-white m-2 p-2">
                <dl className="row">
                  <dt className="col-sm-5 text-muted">Generate Lineups</dt>
                  <dd className="col-sm-7 text-muted">
                    Create Multiple Lineups (11 max)
                  </dd>
                  {/* <dt className="col-sm-5 text-muted">Lineup Builder</dt>
                  <dd className="col-sm-7 text-muted">
                    Create one lineup at a time
                </dd> */}
                  <dt className="col-sm-5 text-muted">My Lineups</dt>
                  {/*<dd className="col-sm-7 text-muted">All saved lineups</dd> */}
                </dl>
              </div>

              <ul className="list-group m-2">
                <li
                  className="d-flex list-group-item bg-dark text-primary justify-content-center"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  data-dismiss="modal"
                  onClick={() => {
                    openAutoLineUpComponent();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <b>Generate Lineups</b>
                </li>
                {/* <li
                  className="d-flex list-group-item bg-dark text-primary justify-content-center"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  data-dismiss="modal"
                  // onClick={handlesignOut}
                  style={{ cursor: "pointer" }}
                >
                  <b>Lineup Builder</b>
                </li>
                <li
                  className="d-flex list-group-item bg-dark text-primary justify-content-center"
                  aria-label="Large"
                  aria-describedby="inputGroup-sizing-sm"
                  data-dismiss="modal"
                  // onClick={handlesignOut}
                  style={{ cursor: "pointer" }}
                >
                  <b>My Lineups</b>
                </li> */}
              </ul>
            </div>

            <div className="modal-footer bg-black">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    game_information_info: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    game_information: (value) => dispatch(setGameInformation(value)),
    update_filtered_team: (value) => dispatch(setTeamFilter(value)),
    view_setter: (value) => dispatch(setMainPageView(value)),
    go_back_boolean: (value) => dispatch(goBackBoolean(value)),
    set_datetime_for_countdown: (value) => dispatch(setMatchDatetime(value)),
    updateFilterTeam: (value) => dispatch(),
    updatePosition: (value) => dispatch(),
    updateFantasyResponsibility: (value) => dispatch(),
    updateSearchString: (value) => dispatch(),
    update_auto_lineup_generation_flag: (value) =>
      dispatch(setAutoLineupGenBarOpenFlag(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GameInformation);
